import React from "react";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./components/pages/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ImprovementNuggets from "./components/pages/ImprovementNuggets";
import EscapingMediocrity from "./components/pages/EscapingMediocrity";
import AboutMe from "./components/pages/AboutMe";
import ABalancedLife from "./content/escapingMediority/ABalancedLife";
import Books from "./components/pages/Books";
import LearnSkillsFaster from "./content/improvementNuggets/LearnSkillsFaster";
import BookRecommendations from "./content/escapingMediority/BookRecommendations";
import DefiningGoal from "./content/escapingMediority/DefiningGoal";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/improvement-nuggets" component={ImprovementNuggets} />
          <Route path="/escaping-mediocrity" component={EscapingMediocrity} />
          <Route path="/about-me" component={AboutMe} />
          <Route path="/books" component={Books} />

          {/* Blog Posts: */}
          <Route path="/a-balanced-life" component={ABalancedLife} />
          <Route path="/learn-skills-faster" component={LearnSkillsFaster} />
          <Route path="/book-recommendations" component={BookRecommendations} />
          <Route path="/defining-goal" component={DefiningGoal} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
